import {
  createOperatorExpenses,
  expenseUploadExcelFile,
  fetchAllOperatorsExpenses,
  fetchOperatorExpensesList,
} from "../../services/expenseService";
import {
  operatorExpensesCreated,
  clearOperatorExpenseList,
  setAllOperatorsExpenses,
  setOperatorExpenseList,
  expenseUploadSheetFailure,
} from "../actions/expenseAction";
import { createAllActionCreators } from "./actionCreatorUtil";

export const clearOperatorExpensesAction = () => (dispatch) => {
  dispatch(clearOperatorExpenseList([]));
};

export const clearOperatorExpensesResponseAction = () => (dispatch) => {
  dispatch(operatorExpensesCreated({}));
};

const exenseActionCreators = {
  fetchAllOperatorExpensesAction: {
    service: fetchAllOperatorsExpenses,
    action: setAllOperatorsExpenses,
    customApiResponse: (response) => {
      response.items = response.items.map((item) => ({ ...item, ...item.expenses }));
      return response;
    },
  },
  fetchOperatorExpensesAction: {
    service: fetchOperatorExpensesList,
    action: setOperatorExpenseList,
  },
  createOperatorExpensesAction: {
    service: createOperatorExpenses,
    action: operatorExpensesCreated,
    customApiResponse: (response, params) => ({
      success: true,
      isCloseModal: params.isCloseModal,
      response,
    }),
  },
  expenseUploadExcelFileAction: {
    service: expenseUploadExcelFile,
    responseNotification: {
      status: true,
      only: true,
    },
    responseNotificationMessage: (response) => response.messageResponse || "Upload successful",
    upload: {
      status: true,
      notificationMessage: "Upload Failed",
      errorAction: expenseUploadSheetFailure,
      errorActionMessage: (err) => (err.error
        ? `${err.message}: ${JSON.stringify(err.error)}`
        : err.message || "Something went wrong"),
    },
  },
};

export const {
  fetchAllOperatorExpensesAction,
  fetchOperatorExpensesAction,
  createOperatorExpensesAction,
  expenseUploadExcelFileAction,
} = createAllActionCreators(exenseActionCreators);
